import get from 'lodash/get';
import set from 'lodash/set';

const KEYS = {
  COORDINATES: 'coordinates',
  GEOLOCATION: 'geoLocation',
  IP_LOCATION: 'ipLocation',
  LOCATION_PAGE_VISIT_LOCATION: 'locationPageVisitLocation',
  DEFAULT_LOCATION: 'defaultLocation'
}

class LocationStorage {
  constructor($log, $sessionStorage) {
    this.$sessionStorage = $sessionStorage;
    this.$log = $log;
    this.storageName = 'locationStorage';
    set($sessionStorage, `${this.storageName}.${KEYS.DEFAULT_LOCATION}`, 'Helsinki')
  }

  /**
   * Saves the name of the city retrieved from geolocation to session storage
   * @param {string} cityName
   */
  setGeolocationCity(cityName) {
    set(this.$sessionStorage, `${this.storageName}.${KEYS.GEOLOCATION}`, cityName);
  }

  /**
   * @returns The saved location retrieved based on geolocation
   */
  getGeolocationCity() {
    return get(this.$sessionStorage, `${this.storageName}.${KEYS.GEOLOCATION}`);
  }

  /**
   * Saves the user's coordinates
   * @param {Object} coordinates
   */
  setCoordinates(coordinates) {
    set(this.$sessionStorage, `${this.storageName}.${KEYS.COORDINATES}`, coordinates);
  }

  /**
   * @returns The saved coordinates based on geolocation. The returned value emulates the coordinates retrieved
   * by the browser's geolocation service, so it's in the format: {
   *  coords: {
   *    latitude: <value>,
   *    longitude: <value>
   *  }
   * }
   */
  getCoordinates() {
    return get(this.$sessionStorage, `${this.storageName}.${KEYS.COORDINATES}`);
  }

  /**
   * Saves the name of the city retrieved from ip address location
   * @param {string} cityName
   */
  setIpAddressCity(cityName) {
    set(this.$sessionStorage, `${this.storageName}.${KEYS.IP_LOCATION}`, cityName);
  }

  /**
   * @returns The saved ip address based location
   */
  getIpAddressCity() {
    return get(this.$sessionStorage, `${this.storageName}.${KEYS.IP_LOCATION}`);
  }

  /**
   * Saves the name of the city retrieved from ip address location
   * @param {string} cityName
   */
  setLocationPageVisitCity(cityName) {
    set(this.$sessionStorage, `${this.storageName}.${KEYS.LOCATION_PAGE_VISIT_LOCATION}`, cityName);
  }

  /**
   * @returns The saved ip address based location
   */
  getLocationPageVisitCity() {
    return get(this.$sessionStorage, `${this.storageName}.${KEYS.LOCATION_PAGE_VISIT_LOCATION}`);
  }

  /**
   * @returns The default city
   */
  getDefaultlocationCity() {
    return get(this.$sessionStorage, `${this.storageName}.${KEYS.DEFAULT_LOCATION}`);
  }

  /**
   * @returns The city based on the predetermined order of priority (geolocation, ip address, location page visit, default)
   */
  getCurrentLocationCity() {
    return this.getGeolocationCity() ||
           this.getLocationPageVisitCity() ||
           this.getDefaultlocationCity();
  }

  reset() {
    set(this.$sessionStorage, this.storageName, {});
  }
}

export default LocationStorage;



// WEBPACK FOOTER //
// ./src/app/common/location/location-storage.js